import { render, staticRenderFns } from "./userCertificate.vue?vue&type=template&id=6698e131&scoped=true&"
import script from "./userCertificate.vue?vue&type=script&lang=js&"
export * from "./userCertificate.vue?vue&type=script&lang=js&"
import style0 from "./userCertificate.vue?vue&type=style&index=0&id=6698e131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698e131",
  null
  
)

export default component.exports